$( document ).ready(function() {
  gsap.to (".counters", {
	scrollTrigger: {
		trigger: ".counters",
		start: "bottom bottom",
		end: "bottom 20%",
        onEnter: counterNumber
    }
  });
  function counterNumber() {
    $('.counter-number').each(function () {
       var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
       $(this).prop('Counter', 0).animate({
          Counter: $(this).text()
       }, {
          duration: 3000,
          step: function (func) {
             $(this).text(parseFloat(func).toFixed(size));
          }
       });
    });
  }
   $('.featured-collection .wrapper, .featured-products .wrapper, .product-collection__recently-content .product-html__product,.healthy-collections .wrapper').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      prevArrow:"<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0752/6432/7979/files/left-arrow.png?v=1692550796' alt='slider arrow image' /></button>",
      nextArrow:"<button type='button' class='slick-next'>><img src='https://cdn.shopify.com/s/files/1/0752/6432/7979/files/right-arrow.png?v=1692550772' alt='slider arrow image' /></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
  });
   $('.healthy-collections .wrapper .collection-block.hidden').removeClass('hidden');
  $('.home-reviews .wrapper').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
  });
  $('.report-block').magnificPopup({
	type: 'image',
    mainClass: 'mfp-with-zoom', 
    gallery:{
    	enabled:true
	},
    zoom: {
      enabled: true, 
      duration: 300,
      easing: 'ease-in-out',
      opener: function(openerElement) {
        return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  });
});